module.exports = __webpack_public_path__ + "static/media/default_fallback_3.739476a8.png";